import { render, staticRenderFns } from "./BusinessHoursInput.vue?vue&type=template&id=4cc1432b"
import script from "./BusinessHoursInput.vue?vue&type=script&lang=ts"
export * from "./BusinessHoursInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports